import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import {
  DeleteGalleryImageRequest,
  GalleryImageApiRequest,
} from '@/data/payload/api/GalleryImageRequest'
import { GalleryImagePresenter } from '@/app/ui/presenters/GalleryImagePresenter'
import { Image } from '@/domain/entities/GalleryImage'
import router from '@/router'
import Vue from 'vue'
import { AuthModule } from './auth'

export interface GalleryImageState {
  galleryImageData: Image
  isLoading: boolean
  paginationParam: Object
}

@Module({ namespaced: true, dynamic: true, store, name: 'galleryImage' })
class GalleryImages extends VuexModule implements GalleryImageState {
  public galleryImageData = new Image(true, '')
  public isLoading = false
  public paginationParam = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'CreateDate',
      type: 'desc',
    },
    search: '',
  }

  @Action
  public async getGalleryImageData() {
    this.setLoading(true)
    const presenter = await container.resolve(GalleryImagePresenter)
    presenter
      .loadGalleryImage(this.paginationParam)
      .then((res: Image) => {
        this.setLoading(false)
        this.setGalleryImageData(res)
        //  console.log('Data', res)
      })
      .catch((error) => {
        this.setLoading(false)
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        router.push('/404/index')
        console.error('error', error)
      })
  }

  @Action
  public async postGalleryImage(params: {
    name: string
    category: string
    fileByte: string
    fileUpload: any
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(GalleryImagePresenter)
    presenter
      .postGalleryImage(
        new GalleryImageApiRequest(
          params.name,
          params.category,
          params.fileByte,
          params.fileUpload
        )
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Gallery Image',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getGalleryImageData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Action
  public async deleteGalleryImage(params: { ids: any }) {
    this.setLoading(true)
    const presenter = await container.resolve(GalleryImagePresenter)
    presenter
      .deleteGalleryImage(new DeleteGalleryImageRequest(params.ids))
      .then((res) => {
        //  console.log('responseee', res)
        Vue.prototype.$notify({
          title: 'Gallery Image',
          message: res.ids.length === 0 ? 'Image has been use' : res.message,
          type: res.ids.length === 0 ? 'error' : 'success',
          duration: 5000,
        })
        this.getGalleryImageData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Mutation
  private setGalleryImageData(galleryImage: Image) {
    this.galleryImageData = galleryImage
  }

  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }
}

export const GalleryImageModule = getModule(GalleryImages)
